import { Grid, Box, Button } from "@mui/material";

import { FC, useEffect, useState } from "react";
import { load, remove } from "../../constants/storage";
import DashboardNavbar from "../../components/DashboardNavbar";
import { H4 } from "../../components/Typography";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-hot-toast";
import NomineeCard from "../../components/NomineeCard";
import { getNomineeList } from "../../redux/actions";
import { useAppDispatch } from "../../store/hooks";

const Nominee: FC = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [nominees, setNominees] = useState([]);
  let navigate = useNavigate();
  const [allocationSum, setAllocationSum] = useState(0);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getUserNomineeList();
    }
  };

  useEffect(() => {
    checkToken();
  }, []);

  const getUserNomineeList = async () => {
    setLoading(true);
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    let token = load("token");
    const data = {
      id: finalUser.id,
      mobile: finalUser.mobile,
      partner: finalUser?.refcode,
    };
    dispatch(getNomineeList(data, `bearer ${token}`))
      .then(async (response: any) => {
        setLoading(false);
        setNominees(response?.nominee ?? []);
        if (response?.nominee) {
          const percentageValues = response?.nominee?.map((nominee: any) => {
            const percentage = nominee.percentage;

            return percentage;
          });
          const sum = percentageValues.reduce(
            (accumulator: any, currentValue: any) => {
              return accumulator + currentValue;
            },
            0
          );

          setAllocationSum(sum);
        }
      })
      .catch((error: any) => {
        setLoading(false);
      });
  };

  return (
    <>
      <DashboardNavbar />
      <Grid
        container
        sx={{
          background: "#F6F6F6",
          height: "100vh",
          justifyContent: "center",
        }}
      >
        {loading ? (
          <Grid
            height="100vh"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </Grid>
        ) : (
          <>
            <Grid
              sx={{
                pl: {
                  md: 9,
                  xs: 2,
                  sm: 2,
                },
                pr: {
                  md: 9,
                  xs: 2,
                  sm: 2,
                },
                pb: 10,
                pt: 2,
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                flex: 1,
              }}
            >
              <Grid
                xs={12}
                sx={{
                  background: "#FFFFFF",
                  p: {
                    md: 4,
                    xs: 2,
                  },
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 2,
                }}
              >
                <H4
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    textAlign: "left",
                    color: "#000",
                    mb: {
                      md: 1,
                      xs: 0,
                    },
                  }}
                  fontWeight={"600"}
                >
                  Manage Nominees
                </H4>
                {nominees.map((item: any) => (
                  <NomineeCard data={item} />
                ))}
                {allocationSum >= 100 || nominees.length === 3 ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 2,
                    }}
                  >
                    <Button
                      type="submit"
                      size="medium"
                      sx={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: 2,
                        padding: 0.5,
                        paddingLeft: 2,
                        color: "#fff",
                        paddingRight: 2,
                        marginTop: 0.5,
                        background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                        fontSize: 14,
                        position: "relative",
                        justifyContent: "center",
                        width: {
                          md: "30%",
                          xs: "90%",
                        },
                        textTransform: "none",
                      }}
                      onClick={() => {
                        navigate("/addNominee", {
                          state: {
                            data: nominees,
                          },
                        });
                      }}
                    >
                      Edit Nominee
                    </Button>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 2,
                    }}
                  >
                    <Button
                      type="submit"
                      size="medium"
                      sx={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: 2,
                        padding: 0.5,
                        paddingLeft: 2,
                        color: "#fff",
                        paddingRight: 2,
                        marginTop: 0.5,
                        background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                        fontSize: 14,
                        position: "relative",
                        justifyContent: "center",
                        width: {
                          md: "30%",
                          xs: "80%",
                        },
                        textTransform: "none",
                      }}
                      onClick={() => {
                        navigate("/addNominee", {
                          state: {
                            data: nominees,
                          },
                        });
                      }}
                    >
                      Add Nominee
                    </Button>
                  </Box>
                )}
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default Nominee;
